import React from 'react';
import reactDom from '../../../common/react/dom/index';
import SponsorsContainer from '../../../components/frontend/sponsors/SponsorsContainer';

export default function init() {
	reactDom(<SponsorsContainer />, 'js-react-sponsors');
}
